<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Le Décret" />
            <LesDecrets />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesDecrets from './LesDecrets.vue';


export default {
    name: 'MouvementPage',
    components: {
        NavBar,
        PageTitle,
        LesDecrets,
        FooterComp,
    }
}
</script>